var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBannerEpointsL(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 844,
    height: 99,
    viewBox: "0 0 844 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4496_29877)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_4496_29877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-66.6919 242.25L254.688 -79.1296",
    stroke: "url(#paint0_linear_4496_29877)",
    strokeWidth: 134.833
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4496_29877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.6098 63.8099L46.6849 65.5266L43.3125 22.2781L63.9303 3.90863L68.6098 63.8099Z",
    fill: "#E60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6292 45.1349L45.744 46.7676C44.3046 46.8802 43.2289 48.1383 43.3414 49.5777L47.0965 97.6119C47.209 99.0513 48.4671 100.127 49.9066 100.014L70.7917 98.3817C72.2312 98.2692 73.3068 97.0111 73.1943 95.5717L69.4392 47.5375C69.3267 46.0981 68.0686 45.0224 66.6292 45.1349Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2018 57.1128L44.104 59.153L44.5122 64.3743L70.61 62.3341L70.2018 57.1128Z",
    fill: "#E60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5304 15.8676C62.0452 10.4179 65.1886 4.65683 63.5513 2.99999C61.914 1.34314 56.116 4.41791 50.6012 9.86768C45.0864 15.3174 41.943 21.0785 43.5803 22.7353C45.2176 24.3922 51.0156 21.3174 56.5304 15.8676Z",
    fill: "#FF2A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.898 72.8553C143.587 71.8444 144.667 71.2693 145.8 71.1821C147.665 71.0427 149.399 70.2061 150.453 68.6637C152.911 65.0648 156.946 59.174 159.786 55.0173C161.59 52.3769 160.91 48.778 158.279 46.9741L111.362 14.8972C108.721 13.0934 105.122 13.7644 103.318 16.4048L93.9856 30.0425C92.9311 31.5849 92.783 33.502 93.3233 35.2884C93.6544 36.369 93.5063 37.5889 92.8179 38.5998C92.1294 39.6106 91.0489 40.1858 89.916 40.2729C88.0512 40.4123 86.3171 41.2489 85.2627 42.7913C77.4025 54.2853 50.4233 93.7344 41.012 107.485C39.2082 110.126 39.8792 113.725 42.5196 115.529L89.4193 147.606C92.0597 149.409 95.6587 148.738 97.4625 146.098L141.713 81.4039C142.768 79.8615 142.916 77.9443 142.375 76.1579C142.044 75.0774 142.192 73.8574 142.881 72.8465L142.898 72.8553Z",
    fill: "#E60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.14 44.3852L96.3209 40.4053C95.8958 40.1146 95.3156 40.2235 95.0249 40.6486C94.7342 41.0736 94.8431 41.6539 95.2681 41.9446L101.087 45.9244C101.512 46.2152 102.092 46.1063 102.383 45.6812C102.674 45.2561 102.565 44.6759 102.14 44.3852Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.592 50.8509L105.773 46.871C105.348 46.5803 104.768 46.6892 104.477 47.1143C104.186 47.5393 104.295 48.1196 104.72 48.4103L110.539 52.3901C110.964 52.6809 111.545 52.572 111.835 52.1469C112.126 51.7218 112.017 51.1416 111.592 50.8509Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.046 57.3116L115.227 53.3318C114.802 53.0411 114.221 53.15 113.931 53.575C113.64 54.0001 113.749 54.5803 114.174 54.8711L119.993 58.8509C120.418 59.1416 120.998 59.0327 121.289 58.6077C121.58 58.1826 121.471 57.6024 121.046 57.3116Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.498 63.7861L124.679 59.8062C124.254 59.5155 123.674 59.6244 123.383 60.0495C123.092 60.4745 123.201 61.0548 123.626 61.3455L129.445 65.3253C129.87 65.616 130.45 65.5071 130.741 65.0821C131.032 64.657 130.923 64.0768 130.498 63.7861Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.95 70.2518L134.131 66.2719C133.706 65.9812 133.126 66.0901 132.835 66.5152C132.544 66.9402 132.653 67.5205 133.078 67.8112L138.897 71.791C139.322 72.0817 139.902 71.9728 140.193 71.5478C140.484 71.1227 140.375 70.5425 139.95 70.2518Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9038 100.915L70.0389 99.6427C68.6185 98.658 67.5205 97.4554 66.745 96.035C65.9694 94.6146 65.6209 93.0896 65.6993 91.4426C65.7777 89.7957 66.379 88.1574 67.5031 86.5104C68.6272 84.8634 70.0041 83.626 71.5029 82.955C73.0105 82.284 74.5529 82.0662 76.1476 82.284C77.7423 82.5019 79.2498 83.1032 80.679 84.0792L82.5438 85.3514C83.9729 86.3274 85.0709 87.5213 85.8465 88.9242C86.622 90.3359 86.9619 91.8609 86.8748 93.5079C86.7876 95.1549 86.1689 96.8193 85.0186 98.4924C83.8684 100.166 82.5438 101.342 81.0362 101.996C79.5287 102.658 77.9863 102.876 76.4003 102.658C74.8143 102.44 73.3155 101.856 71.8951 100.906L71.9038 100.915ZM99.0049 115.276L81.4284 69.7705C81.2715 69.3696 81.3238 68.9252 81.5678 68.5679L82.8662 66.6682C83.4588 65.8055 84.7746 65.9536 85.1493 66.9296L102.726 112.435C102.883 112.836 102.83 113.28 102.586 113.638L101.288 115.537C100.695 116.4 99.3796 116.252 99.0049 115.276ZM73.4898 94.5885L75.3546 95.8607C76.1999 96.4272 77.1149 96.7496 78.0996 96.8454C79.0843 96.9413 79.9121 96.4882 80.6093 95.4686C81.3064 94.449 81.472 93.4469 81.0275 92.5668C80.5831 91.6866 79.9383 90.9721 79.0843 90.4056L77.2194 89.1334C76.3916 88.5495 75.4853 88.1922 74.5006 88.0702C73.5246 87.9482 72.6532 88.4362 71.9125 89.5255C71.2154 90.5451 71.1021 91.5036 71.5726 92.3925C72.0432 93.2813 72.6881 94.0133 73.4985 94.5797L73.4898 94.5885ZM104.512 96.6189L102.647 95.3466C101.244 94.3706 100.146 93.168 99.3709 91.7476C98.5953 90.3272 98.238 88.8022 98.3078 87.1553C98.3775 85.517 98.9788 83.8613 100.12 82.1882C101.262 80.515 102.604 79.3212 104.111 78.6502C105.619 77.9792 107.161 77.7614 108.756 77.9792C110.351 78.1971 111.858 78.7984 113.287 79.7743L115.152 81.0466C116.564 82.0139 117.662 83.2077 118.446 84.6194C119.231 86.0311 119.579 87.5648 119.501 89.2205C119.422 90.8762 118.821 92.5319 117.679 94.205C116.538 95.8782 115.196 97.072 113.688 97.7256C112.181 98.3878 110.63 98.6057 109.035 98.3791C107.44 98.1613 105.933 97.5687 104.512 96.6101V96.6189ZM106.081 90.3272L107.946 91.5995C108.774 92.1485 109.68 92.4709 110.673 92.5755C111.667 92.6801 112.521 92.2095 113.235 91.1638C113.95 90.1181 114.089 89.1508 113.645 88.2794C113.2 87.3993 112.555 86.6847 111.701 86.1183L109.837 84.846C109.009 84.2621 108.103 83.9049 107.118 83.7829C106.142 83.6609 105.279 84.1402 104.538 85.2207C103.798 86.3013 103.702 87.2163 104.155 88.1138C104.608 89.0114 105.253 89.7434 106.081 90.3272Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4496_29877",
    x: -181.779,
    y: -194.217,
    width: 551.555,
    height: 551.555,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 33.7083,
    result: "effect1_foregroundBlur_4496_29877"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4496_29877",
    x1: -66.3383,
    y1: 242.604,
    x2: 255.042,
    y2: -78.776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D90000",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D90000"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4496_29877"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 19,
    width: 844,
    height: 80,
    rx: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4496_29877"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 121,
    height: 99,
    fill: "white",
    transform: "translate(40)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerEpointsL);
export default __webpack_public_path__ + "static/media/banner-epoints-L.959813bb1c19b8ee6106ddd503b9e616.svg";
export { ForwardRef as ReactComponent };